import clsx from 'clsx'

export function WatchlistIcon({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="29"
      viewBox="0 0 23 29"
      fill="#363636"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.3125 0C1.93071 0 0 1.93078 0 4.3125V27.3125C0 27.825 0.272843 28.2986 0.716023 28.5558C1.15921 28.813 1.70574 28.8148 2.15065 28.5605L11.5 23.2182L20.8493 28.5605C21.2942 28.8148 21.8408 28.813 22.284 28.5558C22.7272 28.2986 23 27.825 23 27.3125V4.3125C23 1.93078 21.0692 0 18.6875 0H4.3125ZM17.25 11.5C17.25 10.7061 16.6064 10.0625 15.8125 10.0625H12.9375V7.1875C12.9375 6.3936 12.2939 5.75 11.5 5.75C10.7061 5.75 10.0625 6.3936 10.0625 7.1875V10.0625H7.1875C6.39357 10.0625 5.75 10.7061 5.75 11.5C5.75 12.2939 6.39357 12.9375 7.1875 12.9375H10.0625V15.8125C10.0625 16.6064 10.7061 17.25 11.5 17.25C12.2939 17.25 12.9375 16.6064 12.9375 15.8125V12.9375H15.8125C16.6064 12.9375 17.25 12.2939 17.25 11.5Z"
         className={clsx('fill-[#363636]', className)}
      />
    </svg>
  )
}
